define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../shared/dataLogs", "../../models/UserContext", "../../models/ServerModel", "./serverActions"], function (require, exports, $, ko, log, urls_1, tools, DataLogs, UserContext, ServerModel, ServerActions) {
    "use strict";
    var ServerGroupDetails = /** @class */ (function () {
        function ServerGroupDetails() {
            this.serverId = ko.observable(0);
            this.editModel = ko.observable(new ServerModel());
            this.actions = new ServerActions();
            this.canUserSeePassword = ko.observable(UserContext.hasAccess("Servers.AllowSeePassword") || UserContext.hasAccess("Admin") || UserContext.hasAccess("Servers.Edit") || UserContext.hasAccess("Servers.Delete"));
            this.badRequest = false;
        }
        ServerGroupDetails.prototype.init = function (id) {
            var self = this;
            self.serverId(id);
            self.badRequest = false;
            var getModelCall = tools.ajaxGet({
                url: "/Servers/GetById",
                data: { id: id },
                success: function (result) {
                    if (result.Success) {
                        self.editModel(new ServerModel(result.Data));
                        if (UserContext.hasAccess("Admin") || UserContext.hasAccess("Servers.Edit") || UserContext.hasAccess("Servers.Delete")) {
                            $("#ko-main-content").on("click", ".btn-edit", function (event) {
                                self.actions.editServer(self.editModel().Id(), self.editModel().IpAddress());
                                event.preventDefault();
                            });
                        }
                        self.actions.saveCallback = function (data) {
                            self.editModel(new ServerModel(data));
                            if (self.dataLogs) {
                                self.dataLogs.refreshLogs();
                            }
                        };
                        self.actions.passwordCallback = function (data) {
                            self.editModel().PasswordPreview(data);
                        };
                    }
                    else {
                        self.badRequest = true;
                        log.error(result.Error);
                    }
                }
            });
            $.when(getModelCall).done(function () {
                $("#contextLoader").hide();
                if (self.badRequest) {
                    $("#notFoundContext").show();
                }
                else {
                    $("#mainContext").show();
                }
                self.initLogs();
                ko.applyBindings(self, document.getElementById("ko-main-content"));
            });
        };
        ServerGroupDetails.prototype.hidePassword = function () {
            var self = this;
            self.editModel().PasswordPreview("******");
        };
        ServerGroupDetails.prototype.viewPassword = function () {
            var self = this;
            self.actions.viewServerPasswordConfirm(self.editModel().Id(), self.editModel().IpAddress());
        };
        ServerGroupDetails.prototype.initLogs = function () {
            var self = this;
            if (UserContext.hasAccess("Admin")) {
                self.dataLogs = new DataLogs("Server", self.serverId());
                self.dataLogs.initKendoLogs("divLogsTable");
            }
        };
        return ServerGroupDetails;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/ServersGroups/Details")) {
            var id = urls_1.urls.getIdFromQueryString();
            if (id <= 0) {
                id = urls_1.urls.getIdFromUrl();
            }
            log.log("Initialize Server Details id: " + id);
            $(function () {
                (new ServerGroupDetails()).init(id);
            });
        }
    }, 0);
    return ServerGroupDetails;
});
//# sourceMappingURL=serverDetails.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/serversGroups/serverDetails.js
// module id = 272
// module chunks = 2